// extracted by mini-css-extract-plugin
module.exports = {"rating":"RatingInput_rating__1pWbL"};